import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faTimes, faArrowRight } from '@fortawesome/free-solid-svg-icons';

const CalculatorISPF = () => {
  const [wohneinheiten, setWohneinheiten] = useState(1);
  const [handwerksangebot, setHandwerksangebot] = useState(30000);
  const [ergebnis, setErgebnis] = useState(null);

  useEffect(() => {
    const maxFoerderfaehigOhneISFP = 30000;
    const maxFoerderfaehigMitISFP = 60000;
    const foerderQuoteOhneISFP = 0.15;
    const foerderQuoteMitISFP = 0.20;

    const foerderfaehigOhneISFP = Math.min(handwerksangebot, maxFoerderfaehigOhneISFP * wohneinheiten);
    const foerderfaehigMitISFP = Math.min(handwerksangebot, maxFoerderfaehigMitISFP * wohneinheiten);

    const foerderBetragOhneISFP = foerderfaehigOhneISFP * foerderQuoteOhneISFP;
    const foerderBetragMitISFP = foerderfaehigMitISFP * foerderQuoteMitISFP;
    const differenz = foerderBetragMitISFP - foerderBetragOhneISFP;

    setErgebnis({
      foerderBetragOhneISFP,
      foerderBetragMitISFP,
      differenz,
      foerderfaehigOhneISFP,
      foerderfaehigMitISFP
    });
  }, [wohneinheiten, handwerksangebot]);

  return (
    <div className="w-full bg-white px-6 sm:px-8 lg:px-12 py-16 rounded-2xl border bg-secondary-light mb-8">
      <div className="flex flex-col items-center justify-center gap-12">

        {/* Input Fields */}
        <div className="w-full sm:w-4/5 lg:w-3/4">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-10 mb-12 items-stretch">
            <div className="flex flex-col h-full">
              <label className="block text-2xl font-semibold text-gray-700 mb-4">Anzahl der Wohneinheiten:</label>
              <input
                type="number"
                value={wohneinheiten}
                onChange={(e) => setWohneinheiten(Number(e.target.value))}
                min="1"
                className="w-full p-6 border rounded-lg text-xl focus:outline-none focus:ring-2 focus:ring-primary mt-auto"
              />
            </div>

            <div className="flex flex-col h-full">
              <label className="block text-2xl font-semibold text-gray-700 mb-4">Handwerksangebot pro Wohneinheit (€ inkl. MwSt.):</label>
              <input
                type="number"
                value={handwerksangebot}
                onChange={(e) => setHandwerksangebot(Number(e.target.value))}
                min="1000"
                className="w-full p-6 border rounded-lg text-xl focus:outline-none focus:ring-2 focus:ring-primary mt-auto"
              />
            </div>
          </div>
        </div>

        {/* Results */}
        {ergebnis && (
          <div className="w-full sm:w-4/5 lg:w-3/4 flex flex-col sm:flex-row gap-10 justify-between">
            {/* Ohne iSFP Box */}
            <div className="p-10 bg-white rounded-lg shadow-2xl border border-white w-full sm:w-1/2 lg:w-1/2 text-secondary-dark">
              <h4 className="text-3xl sm:text-4xl lg:text-5xl font-semibold mb-6">Förderung ohne Sanierungsfahrplan (iSFP):</h4>
              <p className="text-xl sm:text-2xl lg:text-3xl mb-4">Maximale Fördersumme: {ergebnis.foerderfaehigOhneISFP.toLocaleString()} €</p>
              <p className="text-xl sm:text-2xl lg:text-3xl mb-4">Förderfähiger Betrag: 15% aus 30.000 €</p>
              <p className="text-2xl font-semibold mb-6">Ihre Förderung ohne iSFP:</p>
              <p className="text-4xl font-semibold mb-6">{ ergebnis.foerderBetragOhneISFP.toLocaleString()} €</p>
              <div className="mt-6 text-xl">
                <p><FontAwesomeIcon icon={faTimes} /> Höhere maximale Fördersumme</p>
                <p><FontAwesomeIcon icon={faTimes} /> Höherer prozentualer Fördersatz</p>
                <p><FontAwesomeIcon icon={faTimes} /> Höhere Fördersumme je Wohneinheit</p>
                <p><FontAwesomeIcon icon={faArrowRight} /> Niedrigere Gesamtfördersumme</p>
                <p><FontAwesomeIcon icon={faArrowRight} /> Niedrigerer prozentualer Fördersatz</p>
              </div>
            </div>

            {/* Mit iSFP Box */}
            <div className="p-10 bg-white text-secondary-dark rounded-lg shadow-2xl border-2 border-primary w-full sm:w-1/2 lg:w-1/2">
              <h4 className="text-3xl sm:text-4xl lg:text-5xl font-semibold mb-6">Förderung mit Sanierungsfahrplan (iSFP):</h4>
              <p className="text-xl sm:text-2xl lg:text-3xl mb-4">Maximale Fördersumme: {ergebnis.foerderfaehigMitISFP.toLocaleString()} €</p>
              <p className="text-xl sm:text-2xl lg:text-3xl mb-4">Förderfähiger Betrag: 20% aus 60.000 €</p>
              <p className="text-2xl font-semibold mb-6">Ihre Förderung mit iSFP:</p>
              <p className="text-4xl font-semibold mb-6">{ ergebnis.foerderBetragMitISFP.toLocaleString()} €</p>
              <div className="mt-6 p-8 bg-white bg-opacity-20 border border-white rounded-lg text-primary">
                <p className="text-3xl font-semibold "><strong>Mit iSFP erhalten Sie:</strong></p>
                <p className="text-3xl font-semibold"><u>{ergebnis.differenz.toLocaleString()}</u> € mehr!</p>
              </div>
              <div className="mt-6 text-xl">
                <p><FontAwesomeIcon icon={faCheck} /> Höhere maximale Fördersumme</p>
                <p><FontAwesomeIcon icon={faCheck} /> Höherer prozentualer Fördersatz</p>
                <p><FontAwesomeIcon icon={faCheck} /> Höhere Fördersumme je Wohneinheit</p>
                <p><FontAwesomeIcon icon={faCheck} /> Kosten für iSFP werden bis zu 50% gefördert</p>
                <p><FontAwesomeIcon icon={faCheck} /> iSFP Gültigkeit: 15 Jahre</p>
                <p><FontAwesomeIcon icon={faCheck} /> Keine Umsetzungspflicht</p>
                <p><FontAwesomeIcon icon={faCheck} /> Auch abweichende Umsetzung möglich</p>
              </div>
            </div>

          </div>
        )}
      </div>
    </div>
  );
};

export default CalculatorISPF;
